import * as React from 'react';
import { useState, useEffect } from "react";
import Modal from "../../../component/Global/Modal";
import { useQuoteStore } from 'src/hooks/quote';
import Helper from 'src/support/Helper';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";

const DeleteQuotePopup = (props) => {
    const [status, SetStatus] = useState(false);
    const [{ DeleteQuotePopup }, { }, { }] = useDOMAttachToSystemStore();
    const quoteDetail = DeleteQuotePopup !== undefined && DeleteQuotePopup.data !== undefined && DeleteQuotePopup.data.current_quote;
    const params = DeleteQuotePopup !== undefined && DeleteQuotePopup.data !== undefined && DeleteQuotePopup.data.params;

    const [{ }, { }, { single_delete_quote, set_is_success_action }] = useQuoteStore();

    useEffect(() => {
        if (DeleteQuotePopup) {
            SetStatus(true)
        }
    }, [DeleteQuotePopup]);

    const onHide = (action = true) => {
        SetStatus(false)
    };

    const onDelete = async () => {
        const res = await single_delete_quote(quoteDetail.quoteLineItemId)
        if (res && res.isSuccessFull)
            set_is_success_action(true)

        onHide()
        removeQuoteEvent();
    };

    //By Ramya Kannan [Quote Removal - Adobe script ]
    function removeQuoteEvent(){
        localStorage.setItem("adobeEventType","quoteRemovalEvent");
        let prodDetails = quoteDetail?.product;
        let cartDetails = {
            "cartType":"Quote",
            "additionSource" : DeleteQuotePopup?.data?.addFrom,
            "quoteID": quoteDetail?.quoteLineItemId,
            "quoteType": "online"

        }
        if(Object.keys(prodDetails).length){
            HelperAdobeEvent.trackingAdobeEvent({prodDetails,cartDetails});
        }
    }

    const reuseDiv = (title) => (
        <tr>
            <td>——</td>
            <td>—— </td>
            <td>—— </td>
        </tr>
    );

    return (
        <>
            <Modal show={status} onHide={() => { onHide() }}>
                <div className="avnet-modal modal-800">
                    <div className="avnet-modal-inner">
                        <button type="button" className="close py-3" data-dismiss="modal"
                            onClick={() => { onHide() }}>×</button>
                        <div className="bs5 modal-header border-0">
                            <h3 className="modal-title m-auto" id="exampleModalLabel">Remove this item from your quote?</h3>
                        </div>
                        <div className="modal-body">
                            {quoteDetail !== undefined &&
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Part Number/Manufacturer  </th>
                                            <th>Qty </th>
                                            <th>Target Unit Price</th>
                                            <th>Currency</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {quoteDetail.quantity1 !== undefined &&
                                            <tr>
                                                <td rowSpan="3">{quoteDetail.erpManufacturerPartNumber} <br />
                                                    By {quoteDetail.manufacturerName}</td>
                                                <td>{quoteDetail.quantity1} </td>
                                                <td>{Helper.valueIsNotNull(quoteDetail.targetUnitPrice) === false ? 0 : quoteDetail.targetUnitPrice} </td>
                                                <td>{quoteDetail.targetCurrency}  </td>
                                            </tr>
                                        }
                                        {quoteDetail.quantity2 !== undefined && quoteDetail.quantity2 > 0 ?
                                            <tr>
                                                <td>{quoteDetail.quantity2} </td>
                                                <td>{Helper.valueIsNotNull(quoteDetail.targetUnitPrice) === false ? 0 : quoteDetail.targetUnitPrice} </td>
                                                <td>{quoteDetail.targetCurrency}  </td>
                                            </tr> :
                                            reuseDiv()
                                        }
                                        {quoteDetail.quantity3 !== undefined && quoteDetail.quantity3 > 0 ?
                                            <tr>
                                                <td>{quoteDetail.quantity3} </td>
                                                <td>{Helper.valueIsNotNull(quoteDetail.targetUnitPrice) === false ? 0 : quoteDetail.targetUnitPrice} </td>
                                                <td>{quoteDetail.targetCurrency}  </td>
                                            </tr> :
                                            reuseDiv()
                                        }
                                    </tbody>
                                </table>
                            }
                        </div>
                        <div className="modal-footer d-flex justify-content-center">
                            <button type="button" className="bs5 btn btn-secondary"
                                onClick={() => { onHide() }}>Cancel</button>
                            <button type="button" className="bs5 btn btn-primary"
                                onClick={() => onDelete()}>Delete</button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default DeleteQuotePopup;